import { IDataStrip } from '../../../../../common/interfaces/promotions.interface';
import { AppType } from './../../../../../common/assets/website-data';
import { Component } from "@angular/core";

@Component({
    selector: 'app-maintenance-feed',
    templateUrl: './maintenance-feed.component.html'
})

export class MaintenanceFeedComponent {
    private readonly maintenanceStart = '10 de mayo a las 8:00 hrs';
    private readonly maintenanceEnd = '11 de mayo a las 9:00 hrs';
  
    private readonly startMessage = 'El carro de compras estará en mantenimiento';
    private readonly duringMessage = 'desde el';
    private readonly untilMessage = 'hasta el';
    private readonly endMessage = 'Lamentamos las molestias.';
  
    data: IDataStrip = {
      text: `
        <span>
          ${this.startMessage} ${this.duringMessage} <br><strong>${this.maintenanceStart}</strong> ${this.untilMessage} <strong>${this.maintenanceEnd}</strong>. ${this.endMessage}
        </span>
      `.trim()
    };
  }
  